import { render, staticRenderFns } from "./freezeBalance.vue?vue&type=template&id=6517325d&scoped=true&"
import script from "./freezeBalance.vue?vue&type=script&lang=js&"
export * from "./freezeBalance.vue?vue&type=script&lang=js&"
import style0 from "./freezeBalance.vue?vue&type=style&index=0&id=6517325d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6517325d",
  null
  
)

export default component.exports